import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Row, Col, Form, Button, Modal, Table } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import $ from 'jquery';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';
//import Ratemarquee from '../rate/Ratemarquee';
import '../../mcss/common.css';
import * as Picklist from "../Picklist";
import AsyncSelect from 'react-select/async';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import DialogYesNo from '../Dialog_Yes_No';

function NewRequestCNCARD() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [entityType, setEntityType] = useState(sessionStorage.entityType);


    const [reqReference, setReqReference] = useState("A");

    const [reqProduct, setReqProduct] = useState("TT");
    const [reqIsd, setReqIsd] = useState("0");
    const [reqPurpose, setReqPurpose] = useState("0");
    const [reqBenCountry, setReqBenCountry] = useState("");
    const [reqQuantity, setReqQuantity] = useState("");
    const [reqSellRate, setReqSellRate] = useState("");
    const [reqPan, setReqPan] = useState("");
    const [reqIssuer, setReqIssuer] = useState("0");
    const [reqTenure, setReqTenure] = useState("TOM");
    const [userRight, setUserRight] = useState([]);

    const [panTCS, setPanTCS] = useState([]);
    const [showConfirmBox, setShowConfirmBox] = useState(false);
    const [reqDateCnCard, setReqDateCnCard] = useState(new Date());
    const [reqBranchAllowed, setReqBranchAllowed] = useState("0");
    const [ddReqPayBankOptions, setDdReqPayBankOptions] = useState([]);
    const [ddReqBranchOptionsAllowed, setDdReqBranchOptionsAllowed] = useState([]);
    const [reqAgentAllowed, setReqAgentAllowed] = useState("0");
    const [ddReqAgentOptionsAllowed, setDdReqAgentOptionsAllowed] = useState([]);
    const [reqBranch, setReqBranch] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);
    const [reqPayBankCode, setReqBankCode] = useState("0");
    const [reqPayBankName, setReqBankName] = useState("");
    const [reqProductCnCard, setReqProductCnCard] = useState("CNCARD");
    const [reqLoanAccountNo, setReqLoanAccountNo] = useState("");
    const [reqLoanCoApplicant, setReqLoanCoApplicant] = useState("");
    const [reqPayBankRefNo, setReqPayBankRefNo] = useState("");
    const [reqPayBankAmnt, setReqPayBankAmnt] = useState(0);
    const [reqPayBankDate, setReqPayBankDate] = useState(new Date());
    const [payListDataCnCard, setPayListDataCnCard] = useState([]);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [msgText, setMsgText] = useState("");
    const [reqLoanCoApplicantPassport, setReqLoanCoApplicantPassport] = useState("");
    const [reqLoanCoApplicantPan, setReqLoanCoApplicantPan] = useState("");
    const [reqLoanApplicant, setReqLoanApplicant] = useState("");
    const [reqLoanApplicantPassport, setReqLoanApplicantPassport] = useState("");
    const [reqLoanApplicantPan, setReqLoanApplicantPan] = useState("");
    const [invAmountCnCard, setInvAmountCnCard] = useState("");
    const [ddSrchBranOptions, setDdSrchBranOptions] = useState([]);
    const [srchBranSelect, setSrchBranSelect] = useState([]);
    const [srchBran, setSrchBran] = useState("0");
    const [isMsgBoxCnCard, setMsgBoxCnCard] = useState(false);
    const [msgTextCnCard, setMsgTextCnCard] = useState("");
    const [openCnCardModal, setOpenCnCardModal] = useState(false);
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'NEWREQUEST_CN_CARD'], function (result) {
                let resp = JSON.parse(result);
                setUserRight(resp);
                if (resp.query === '1') {
                    onChangeRefrence("A");
                    Common.callApi(Common.apiUser, [sid, 'branchallowedselect'], function (result) {
                        let resp2 = JSON.parse(result);
                        setDdSrchBranOptions(resp2);
                        if (resp2.length === 2) {
                            setSrchBranSelect(resp2[1]);
                            setSrchBran(resp2[1].value);
                            console.log(resp2);
                        }
                    });
                    if (sessionStorage.entityType === "B") {
                        Common.callApi(Common.apiUser, [sid, 'branchallowed'], function (result) {
                            let resp = JSON.parse(result);
                            setDdReqBranchOptionsAllowed(resp);
                            if (resp.length === 2) {
                                handleBranchChangeCnCard(resp[1].value);
                            }
                        });
                    } else if (entityType === "A") {
                        setReqReference("A");
                        Common.callApi(Common.apiEntity, [sid, 'agentbranchlink', sessionStorage.entityId], function (result) {
                            let resp = JSON.parse(result);
                            setDdReqBranchOptionsAllowed(resp.oneBranch);
                            handleBranchChangeCnCard(resp.oneBranch[0].value);
                            setReqAgentAllowed(resp.oneAgent[0].value);
                        });

                    }
                    Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentall', reqBranch], function (result) {
                        setDdReqAgentOptions(JSON.parse(result));
                    });
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, entityType]);

    function handleBranchChangeCnCard(v) {
        setReqBranchAllowed(v);
        if (v === "0" || v === "") {
            setDdReqPayBankOptions([]);
            return;
        }
        Common.callApi(Common.apiBank, [sid, 'ddlistjsonbranchwise', v], function (result3) {
            setDdReqPayBankOptions(JSON.parse(result3));
        });
    }
    function onChangeRefrence(id) {
        if (id === "S") {
            setReqAgentAllowed("0");
        }
        setReqReference(id);
        if (id === "A") {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentall', reqBranch], function (result) {
                setDdReqAgentOptionsAllowed(JSON.parse(result));
            });
        } else {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagent', 0], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
        }
    }
    function handleAgentCnCardChange(v) {
        setReqAgentAllowed(v);
        if (v === "13") {
            setReqBankCode("59");
            setReqBankName("Avanse Postpaid");
        } else {
            setReqBankCode("0");
            setReqBankName("");
        }
    }
    function handleReqPayBank(v, t) {
        setReqBankCode(v);
        setReqBankName(t);
    }
    function btnAddPayment() {
        $(".loader").show();
        var msg = [], i = 0;
        if (reqPayBankCode == "0" || reqPayBankCode === "" || reqPayBankRefNo === "" || reqPayBankAmnt === "" || reqPayBankDate == null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((reqPayBankCode == "0" || reqPayBankCode === "") ? "Bank" : "");
            msg[i++] = (reqPayBankRefNo === "" ? "Bank Reference" : "");
            msg[i++] = (reqPayBankAmnt === "" ? "Amount" : "");
            msg[i++] = (reqPayBankDate === null ? "Pay Date" : "");
            // setMsgBoxCnCard(true);
            // setMsgTextCnCard(Common.buildMessageFromArray(msg));
            // setOpenCnCardModal(false);
        } else {
            $(".loader").hide();
            const obj = {
                key: Common.getRandomString(),
                pay_bankcode: reqPayBankCode,
                pay_bankname: reqPayBankName,
                pay_refno: reqPayBankRefNo,
                pay_amnt: reqPayBankAmnt,
                pay_date: Common.dateYMD(reqPayBankDate)
            }
            setPayListDataCnCard(Common.arrayAddItem(payListDataCnCard, obj));
            setReqPayBankAmnt("");
            setReqBankCode("0");
            setReqBankName("");
            setReqPayBankRefNo("");
            setReqBankName("");
        }
    }
    function deletePaymentCnCard(key) {
        setPayListDataCnCard(Common.arrayRemoveItem(payListDataCnCard, 'key', key));
        setRefreshCounter(refreshCounter + 1);
    }
    function onSubmitCnCard() {
        var msg = [], i = 0;
        if (reqBranchAllowed == "0" || reqAgentAllowed === "0" || invAmountCnCard === "" || invAmountCnCard === "0" || reqDateCnCard == null ||
            (reqAgentAllowed == "13" && (reqLoanAccountNo === "" || reqLoanApplicant === "" || reqLoanApplicantPassport === "" || reqLoanApplicantPan === ""
                || reqLoanCoApplicant === "" || reqLoanCoApplicantPassport === "" || reqLoanCoApplicantPan === ""))
        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqDateCnCard == null ? "Request Date" : "");
            msg[i++] = (reqBranchAllowed === "0" ? "Branch" : "");
            msg[i++] = (reqAgentAllowed === "0" ? "Agent" : "");
            msg[i++] = ((invAmountCnCard === "0" || invAmountCnCard === "") ? "Invoice Amount" : "");
            if (reqAgentAllowed == "13") {
                msg[i++] = (reqLoanAccountNo === "" ? "Loan Acct Num" : "");
                msg[i++] = (reqLoanApplicant === "" ? "Loan Applicant" : "");
                msg[i++] = (reqLoanApplicantPassport === "" ? "Loan applicant passport" : "");
                msg[i++] = (reqLoanApplicantPan === "" ? "Loan Applicant PAN" : "");
                msg[i++] = (reqLoanCoApplicant === "" ? "Loan Co Applicant" : "");
                msg[i++] = (reqLoanCoApplicantPassport === "" ? "Loan co appplicant passport " : "");
                msg[i++] = (reqLoanCoApplicantPan === "" ? "Loan co applicant PAN" : "");
            }
            setMsgBoxCnCard(true);
            setMsgTextCnCard(Common.buildMessageFromArray(msg));
            setOpenCnCardModal(false);
        } else {
            if (reqAgentAllowed == "13") {
                const obj = {
                    key: Common.getRandomString(),
                    pay_bankcode: reqPayBankCode,
                    pay_bankname: reqPayBankName,
                    pay_refno: "POSTPAID",
                    pay_amnt: invAmountCnCard,
                    pay_date: Common.dateYMD(reqDateCnCard)
                }
                setPayListDataCnCard(Common.arrayAddItem(payListDataCnCard, obj));
            }
            setMsgBoxYN(true);
            setOpenCnCardModal(false);
            setMsgTextYN("Do you confirm to save changes.");
        }
    }
    function resetCnCardModal() {
        setReqAgentAllowed("0");
        setReqLoanAccountNo("");
        setReqLoanApplicant("");
        setReqLoanApplicantPassport("");
        setReqLoanApplicantPan("");
        setReqLoanCoApplicant("");
        setReqLoanCoApplicantPassport("");
        setReqLoanCoApplicantPan("");
        setInvAmountCnCard("");
        setPayListDataCnCard([]);
        setReqBankCode("0");
        setReqPayBankRefNo("");
        setReqPayBankAmnt("");
        setReqPayBankDate(new Date());
        setReqDateCnCard(new Date());
    }
    function saveDataCnCard() {
        const obj = {
            reqBranchAllowed: reqBranchAllowed,
            reqAgentAllowed: reqAgentAllowed,
            reqReference: reqReference,
            reqProductCnCard: reqProductCnCard,
            invAmountCnCard: invAmountCnCard,
            reqLoanAccountNo: reqLoanAccountNo,
            reqLoanApplicant: reqLoanApplicant,
            reqLoanApplicantPassport: reqLoanApplicantPassport,
            reqLoanApplicantPan: reqLoanApplicantPan,
            reqLoanCoApplicant: reqLoanCoApplicant,
            reqLoanCoApplicantPassport: reqLoanCoApplicantPassport,
            reqLoanCoApplicantPan: reqLoanCoApplicantPan,
            payListDataCnCard: payListDataCnCard,
            reqDateCnCard: Common.dateYMD(reqDateCnCard)
        }
        Common.callApi(Common.apiNewRequestCnCard, [sid, "savedata", JSON.stringify(obj)], result => {
            let res = JSON.parse(result);
            if (res.err !== "") {
                setOpenCnCardModal(false);
                setMsgBoxCnCard(true);
                setMsgTextCnCard(res.err);
                if (reqAgentAllowed === "13") setPayListDataCnCard([]);
            } else {
                setOpenCnCardModal(false);
                // searchRequest(1);
                resetCnCardModal();
            }
        });
        setMsgBoxYN(false);
    }
    function handleCnCardConfirmModal() {
        setMsgBoxYN(false);
        setOpenCnCardModal(true);
        if (reqAgentAllowed === "13") setPayListDataCnCard([]);
    }



    return (
        <>
            <Loginheader></Loginheader>

            <Menu></Menu>

            <Container>

                <Row>
                    <Col>
                        <h2>CN/CARD</h2>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group >
                            <Form.Label>Request Date<span className="mandatory">*</span></Form.Label>
                            <DatePicker className="form-control"
                                selected={reqDateCnCard}
                                onChange={(date) => setReqDateCnCard(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Branch<span className="mandatory">*</span></Form.Label>
                            <Form.Select
                                value={reqBranchAllowed}
                                onChange={(e) => handleBranchChangeCnCard(e.target.value)}
                                disabled={ddReqBranchOptionsAllowed.length === 2} >
                                {ddReqBranchOptionsAllowed.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group >
                            <Form.Label>Reference<span className="mandatory">*</span></Form.Label>
                            <Form.Select
                                value={reqReference}
                                onChange={(e) => onChangeRefrence(e.target.value)}
                                disabled >
                                <option value="S">Self</option>
                                <option value="A">Agent</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                            <Form.Select
                                value={reqAgentAllowed}
                                onChange={(e) => handleAgentCnCardChange(e.target.value)}
                                disabled={entityType === 'A'} >
                                {ddReqAgentOptionsAllowed.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group >
                            <Form.Label>Inovice Amount<span className="mandatory">*</span></Form.Label>
                            <Form.Control type="text" placeholder="Invoice Amount" maxLength={10}
                                onChange={(e) => Common.validateDecValue(e.target.value, setInvAmountCnCard)}
                                value={invAmountCnCard} autoComplete="off" />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='divHide'>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Product<span className="mandatory">*</span></Form.Label>
                            <Form.Select
                                value={reqProductCnCard}
                                onChange={(e) => setReqProductCnCard(e.target.value)}  >
                                <option value="CNCARD">CNCARD</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <h5>Loan Related Details</h5>
                </Row>
                <Row>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Loan Account No {reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                            <Form.Control type="text" placeholder="Loan Account No" maxLength={50} autoComplete="off"
                                value={reqLoanAccountNo}
                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqLoanAccountNo)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Loan Applicant {reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                            <Form.Control type="text" placeholder="Loan Applicant" maxLength={50} autoComplete="off"
                                value={reqLoanApplicant}
                                onChange={(e) => Common.validateAlpNumSpl1Value(e.target.value, setReqLoanApplicant)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Loan Applicant Passport {reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                            <Form.Control type="text" placeholder="Loan Applicant Passport" maxLength={50} autoComplete="off"
                                value={reqLoanApplicantPassport}
                                onChange={(e) => setReqLoanApplicantPassport(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Loan Applicant Pan{reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                            <Form.Control type="text" placeholder="Loan Applicant Pan" maxLength={50} autoComplete="off"
                                value={reqLoanApplicantPan}
                                onChange={(e) => setReqLoanApplicantPan(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Loan Co Applicant{reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                            <Form.Control type="text" placeholder="Loan Co Applicant" maxLength={50} autoComplete="off"
                                value={reqLoanCoApplicant}
                                onChange={(e) => Common.validateAlpNumSpl1Value(e.target.value, setReqLoanCoApplicant)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Loan Co App Passport{reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                            <Form.Control type="text" placeholder="Loan Co App Passport" maxLength={50} autoComplete="off"
                                value={reqLoanCoApplicantPassport}
                                onChange={(e) => setReqLoanCoApplicantPassport(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3'>
                        <Form.Group>
                            <Form.Label>Loan Co App Pan{reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                            <Form.Control type="text" placeholder="Loan Co App Pan" maxLength={50} autoComplete="off"
                                value={reqLoanCoApplicantPan}
                                onChange={(e) => setReqLoanCoApplicantPan(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <h5>Payment Details</h5>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Bank </Form.Label>
                            <Form.Select
                                value={reqPayBankCode}
                                onChange={(e) => handleReqPayBank(e.target.value, e.target.options[e.target.selectedIndex].text)}
                                disabled={reqAgentAllowed === "13"}
                            >
                                {ddReqPayBankOptions.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {
                        reqAgentAllowed !== "13" &&
                        <>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Bank Reference No</Form.Label>
                                    <Form.Control type="text" placeholder="Reference Number"
                                        maxLength={50} autoComplete="off"
                                        value={reqPayBankRefNo}
                                        disabled={reqAgentAllowed === "13"}
                                        onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqPayBankRefNo)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>INR Amount</Form.Label>
                                    <Form.Control type="text" placeholder="INR Amount"
                                        maxLength={10} autoComplete="off"
                                        value={reqPayBankAmnt}
                                        disabled={reqAgentAllowed === "13"}
                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqPayBankAmnt)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>Date<span className="mandatory">*</span></Form.Label>
                                    <DatePicker className="form-control"
                                        selected={reqPayBankDate}
                                        onChange={(date) => setReqPayBankDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                        }
                                        disabled={reqAgentAllowed === "13"}
                                    />
                                </Form.Group>
                            </Col>
                        </>
                    }
                </Row>
                {
                    reqAgentAllowed !== "13" &&
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>&nbsp;</Form.Label><br></br>
                                <Button variant="outline-success" size="sm" onClick={(e) => btnAddPayment()} >Add</Button>
                            </Form.Group>
                        </Col>
                    </Row>
                }

                {
                    payListDataCnCard.length > 0 &&
                    <Row>
                        <Col>
                            <Table responsive striped bordered>
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>Bank</th>
                                        <th>Ref no</th>
                                        <th>Amount</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        payListDataCnCard.map((item, index) => (
                                            <tr>
                                                <td>
                                                    <span className='handCursor colorThemeBlue' onClick={() => deletePaymentCnCard(item.key)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </span>
                                                </td>
                                                <td>{item.pay_bankcode + " " + item.pay_bankname}</td>
                                                <td>{item.pay_refno}</td>
                                                <td>{item.pay_amnt}</td>
                                                <td>{item.pay_date}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
                <hr />
                <Row>
                    <Col>
                        <Button size='sm' variant="success" className='btn_admin' onClick={() => onSubmitCnCard()}>Submit</Button>
                        &nbsp;
                        <Button size='sm' variant="secondary" className='btn_admin' onClick={() => { setOpenCnCardModal(false); resetCnCardModal() }}>Cancel</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>

            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showConfirmBox}
                onHide={() => setShowConfirmBox(false)}

                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Cover Request Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>
                        {
                            reqPan !== "" ?
                                <>
                                    <Row>
                                        <Col>
                                            TT/DD till date (INR) : {Math.round(panTCS.forex)}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            This : {1 * reqQuantity * reqSellRate}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            Total : {Math.round(((1 * panTCS.forex) + (1 * reqQuantity * reqSellRate)))}
                                        </Col>
                                    </Row>
                                </> : null
                        }

                        <Row>
                            <Col>
                                Product : {reqProduct}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                ISD : {reqIsd}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Quantity : {reqQuantity}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Sale Rate :  {reqSellRate}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Tenure : {reqTenure}
                            </Col>
                        </Row>
                    </h3>
                    <Row className='divHide'>
                        <Col>
                            <b>Country : {reqBenCountry}</b>
                        </Col>
                        <Col>
                            <b>Bank : {reqIssuer} </b>
                        </Col>
                        <Col>
                            <b>Purpose : {reqPurpose} </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            {/* <Button variant="outline-success" size="sm" onClick={(e) => saveData()} >I Confirm</Button> */}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => setShowConfirmBox(false)} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => saveDataCnCard()} onNo={(e) => handleCnCardConfirmModal()}>
                {msgTextYN}
            </DialogYesNo>
        </>
    );
}
export default NewRequestCNCARD;